import React from 'react';
import './StrategyCard.css';

const StrategyCard = ({
  strat,
  imageSrc,
  onOpen,
  onToggleFavorite,
  onDelete,
  favoriteLabel,
  lastUpdated,
  isSelected,
  onToggleSelected,
}) => {
  return (
    <div className={`strategy-card ${isSelected ? 'is-selected' : ''}`} onClick={() => onOpen(strat)}>
      <img
        src={imageSrc}
        alt={strat.map}
        className="strategy-map-thumbnail"
      />
      <div className="strategy-info">
        <div className="strategy-header">
          <span className="strategy-name">{strat.name}</span>
          <div className="strategy-actions">
            {typeof onToggleSelected === 'function' && (
              <button
                type="button"
                className={`strategy-select ${isSelected ? 'is-selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleSelected(strat.id);
                }}
                title={isSelected ? 'Remove from export selection' : 'Add to export selection'}
              >
                {isSelected ? 'Selected' : 'Select'}
              </button>
            )}
            {typeof onDelete === 'function' && (
              <button
                type="button"
                className="strategy-delete"
                onClick={(e) => onDelete(e, strat)}
                title="Delete strategy"
              >
                Delete
              </button>
            )}
            <span
              className="favorite-star"
              onClick={(e) => onToggleFavorite(e, strat)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onToggleFavorite(e, strat);
                }
              }}
              title="Toggle favorite"
            >
              {favoriteLabel}
            </span>
          </div>
        </div>

        <div className="strategy-tags">
          <span className="tag">{strat.map}</span>
          <span className="tag">{strat.mode?.toUpperCase() || 'MODE'}</span>

          {(strat.mode === 'SND' || strat.mode === 'CONTROL') &&
            strat.tags?.phases?.includes('Attack') && (
              <span className="tag attack-chip">ATTACK</span>
            )}
          {(strat.mode === 'SND' || strat.mode === 'CONTROL') &&
            strat.tags?.phases?.includes('Defense') && (
              <span className="tag defense-chip">DEFENSE</span>
            )}
        </div>

        <div className="subtag-row">
          {strat.tags?.zones?.map((z, i) => (
            <span key={`zone-${i}`} className="subchip">
              {z}
            </span>
          ))}
          {strat.tags?.phases?.map((p, i) => (
            <span key={`phase-${i}`} className="subchip">
              {p}
            </span>
          ))}
          {strat.tags?.styles?.map((s, i) => (
            <span key={`style-${i}`} className="subchip">
              {s}
            </span>
          ))}
        </div>

        <div className="last-updated">Last updated {lastUpdated}</div>
      </div>
    </div>
  );
};

export default StrategyCard;
